import XLSX from 'sheetjs-style';
import moment from 'moment';
import { msToHMS } from '../../helpers';

const formatBreaks = (breaks) => {
  if (!breaks || breaks.length === 0) return '-';
  return breaks
    .map(
      (b) =>
        `${b.type !== null ? b.type.name : 'Other'}${
          b.type?.shortCode ? ` (${b.type.shortCode})` : ''
        }: ${moment(b.startTime).format('h:mm:ss A')} - ${moment(
          b.endTime
        ).format('h:mm:ss A')}`
    )
    .join('; ');
};

const WorksessionRequestsExcel = (requests) => {
  const wb = XLSX.utils.book_new();

  const subHeading = [
    'Team Member',
    'Project',
    'Original Duration',
    'Original Check-in',
    'Original Check-out',
    'Updated Duration',
    'Updated Check-in',
    'Updated Check-out',
    'Old Breaks',
    'Updated Breaks',
    'Requested Date',
    'Reason',
    'Status',
  ];

  const excelRows = requests.map((req) => ({
    teamMember: `${req.user.firstName} ${req.user.lastName || ''}`,
    project: req.newProject ? req.newProject.title : req.oldProject.title,
    originalDuration: msToHMS(req.oldWorkSessionSeconds * 1000),
    originalCheckIn: moment(req.oldCheckInDate).format(
      'MMM Do, YYYY h:mm:ss A'
    ),
    originalCheckOut: moment(req.oldCheckOutDate).format(
      'MMM Do, YYYY h:mm:ss A'
    ),
    updatedDuration: msToHMS(req.newWorkSessionSeconds * 1000),
    updatedCheckIn: moment(req.newCheckInDate).format('MMM Do, YYYY h:mm:ss A'),
    updatedCheckOut: moment(req.newCheckOutDate).format(
      'MMM Do, YYYY h:mm:ss A'
    ),
    oldBreaks: formatBreaks(req.oldBreak),
    updatedBreaks: formatBreaks(req.newBreak),
    requestedDate: moment(req.requestedDate).format('MMM Do, YYYY h:mm A'),
    reason: req.reason || '-',
    status: req.status
      ? req.status.charAt(0).toUpperCase() + req.status.slice(1)
      : '-',
  }));

  const ws = XLSX.utils.json_to_sheet(excelRows, {
    skipHeader: true,
    origin: 'A2',
  });

  XLSX.utils.sheet_add_aoa(ws, [subHeading], {
    skipHeader: true,
    origin: 'A1',
  });

  const range = XLSX.utils.decode_range(ws['!ref']);

  for (let C = 0; C < 26; C += 1) {
    const cellAddress = { c: C, r: 0 };
    const cellRef = XLSX.utils.encode_cell(cellAddress);
    if (!ws[cellRef]) ws[cellRef] = { t: 's', v: '' };
    ws[cellRef].s = {
      font: { bold: true },
      fill: { fgColor: { rgb: 'dddddd' } },
    };
  }

  const totalColumns = range.e.c + 1;
  ws['!cols'] = Array(totalColumns).fill({ wpx: 120 });

  XLSX.utils.book_append_sheet(wb, ws, 'WS Edit Requests');
  XLSX.writeFile(wb, 'worksession_edit_requests.xlsx');
};

export default WorksessionRequestsExcel;
